import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AppLayout from "@/layouts/AppLayout.vue";
import {computed, ref} from "vue";
import CowImagesAnnotationLeftMenu from "@/views/CowImagesAnnotation/CowImagesAnnotationLeftMenu.vue";
import CowImagesAnnotationPage from "@/views/CowImagesAnnotation/CowImagesAnnotationPage.vue";
import CowImagesAnnotationFooter from "@/views/CowImagesAnnotation/CowImagesAnnotationFooter.vue";
import {
  AnnotatableImagesStoreManager
} from "@/store/Spatial2DAnnotation/manager/AnnotatableImagesStoreManager";

// ------------------------------
//  Images selection listener
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'CowImagesAnnotationView',
  setup(__props) {


const annotatableImages = computed(() => {
  return AnnotatableImagesStoreManager.store.entries;
})

const cowImagesAnnotationPageRef = ref();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppLayout, null, {
    "left-menu": _withCtx(() => [
      _createVNode(CowImagesAnnotationLeftMenu, { "annotatable-images": _unref(annotatableImages) }, null, 8, ["annotatable-images"])
    ]),
    page: _withCtx(() => [
      _createVNode(CowImagesAnnotationPage, {
        "annotatable-images": _unref(annotatableImages),
        ref_key: "cowImagesAnnotationPageRef",
        ref: cowImagesAnnotationPageRef
      }, null, 8, ["annotatable-images"])
    ]),
    "page-footer": _withCtx(() => [
      _createVNode(CowImagesAnnotationFooter, {
        images: _unref(annotatableImages),
        "cow-images-annotation-page-ref": cowImagesAnnotationPageRef.value
      }, null, 8, ["images", "cow-images-annotation-page-ref"])
    ]),
    _: 1
  }))
}
}

})